import { backendUrl } from '@common/contracts';
// Normalizes an image URL, prepending backendUrl when it is not a full URL
export const normalizeImageUrl = (url) => {
    if (!url)
        return undefined;
    return url.startsWith('http') ? url : `${backendUrl}${url}`;
};
